<template>
  <div class="hot-item">
    <el-row :gutter="isPc == 1 ? 16 : 0">
      <el-col :span="isPc == 1 ? 8 : 24" v-for="item in newsListRes" :key="item.newsId">
        <div class="news-item items-center hand" @click="toDetails(item)">
          <img :src="item.newsImage" class="news-img hand" />
          <div class="news-info">
            <time class="text-grey font14">{{ item.releaseTime }}</time>
            <h3 class="text-black font16">
              {{ item.newsTitle }}
            </h3>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getNewsList } from "@/assets/api/news.js";

export default {
  computed: {
    ...mapState(["isPc"]),
  },
  props: {
    tag: {
      type: String,
      default: "",
    },
  },
  created() {
    this.init();
  },
  data() {
    return {
      newsListRes: [],
    };
  },
  created() {
    console.log(this.tag);
    this.init();
  },
  watch: {
    tag(val, old) {
      console.log("===", val);
      console.log("！！！", old);
      if (val != old) {
        this.init();
      }
    },
  },
  methods: {
    init() {
      getNewsList({
        orderByColumn: "releaseTime",
        isAsc: "desc",
        typeId: "",
        tag: this.tag,
        pageNum: 1,
        pageSize: 6,
        slideshow: 0,
      }).then((res) => {
        this.newsListRes = res.data.rows.map((item) => {
          item.newsImage = !/^http/.test(item.newsImage)
            ? this.$imgUrl + item.newsImage
            : item.newsImage;
          return item;
        });
      });
    },
    toDetails(item) {
      if (item.url) {
        window.open(item.url, "_blank");
      } else {
        localStorage.setItem('newsId', item.newsId);
        let path = item.seoUrl ? item.seoUrl : item.newsId
        this.$router.push({
          path: `/${path}.html`,
        });
      }
    },
    generateSlug(title) {
      // 将标题中的空格替换为连字符
      let slug = title.toLowerCase().replace(/\s+/g, '-');
      // 将连字符替换为单个连字符
      slug = slug.replace(/-+/g, '');
      slug = slug.replace(/:+/g, '');
      return slug;
    },
  },
};
</script>

<style lang="less" scoped>
.hot-topic {
  .news-item {
    padding: 15px 18px 14px 15px;
    background-color: #fff;
    margin-top: 20px;

    img {
      width: 113px;
      height: 111px;
      object-fit: cover;
      margin-right: 17px;
    }

    time {
      font-family: NotoSansCJKTC;
      font-weight: bold;
      line-height: 1.71;
      letter-spacing: 0.7px;
    }

    h3 {
      font-family: NotoSansCJKTC;
      font-weight: bold;
      line-height: 1.88;
      letter-spacing: 2.4px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
      margin-top: 6px;
    }
  }
}

@media screen and (max-width: 768px) {
  .hot-topic {
    margin: 10px;

    .news-item {
      padding: 13px 8px 12px 13px;
      background-color: #fff;
      margin-top: 10px;

      img {
        width: 97px;
        height: 95px;
        object-fit: cover;
        margin-right: 15px;
      }

      time {
        font-family: NotoSansCJKTC;
        font-size: 11px;
        font-weight: bold;
        line-height: 1.73;
        letter-spacing: 0.55px;
      }

      h3 {
        margin-top: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/hot-item.vue